export const getVueSelectErrorClass = (thereIsError) => {
    return thereIsError ? 'border rounded-lg border-danger is-invalid' : ''
}

export const stringIsAlphanumeric = (str) => {
    const containsUppercase = /[A-Z]/.test(str)
    const containsLowercase = /[a-z]/.test(str)
    const containsNumber = /[0-9]/.test(str)
    return (containsUppercase || containsLowercase) && containsNumber
}